import PersistentStorage from '../services/storage';
import { setCookie } from '../utils';
import { history } from '../history';

export const userConstants = {
    USER_LOGIN_REQUEST: 'USER_LOGIN_REQUEST',
    USER_LOGIN_SUCCESS: 'USER_LOGIN_SUCCESS',
    USER_LOGIN_FAILURE: 'USER_LOGIN_FAILURE',
    USER_LOGOUT_SUCCESS: 'USER_LOGOUT_SUCCESS',
    PERMS_UPDATED_SUCCESS: 'PERMS_UPDATED_SUCCESS',
    PREVIOUS_HREF_ADDED_SUCCESS: 'PREVIOUS_HREF_ADDED_SUCCESS'
};

const finishLogOut = () => ({ type: userConstants.USER_LOGOUT_SUCCESS });
export const finishLogIn = user => ({ type: userConstants.USER_LOGIN_SUCCESS, payload: user });
export const addPreviousHref = href => ({ type: userConstants.PREVIOUS_HREF_ADDED_SUCCESS, payload: href });
export const setCurrentUserPermissions = perms => ({ type: userConstants.PERMS_UPDATED_SUCCESS, payload: perms });

export const clearLocalStorage = () => {
    localStorage.removeItem('transferDataToReviewPage');
    localStorage.removeItem('transferDataToPaymentPage');
    localStorage.removeItem('conditionLicenseFilterURL');
    localStorage.removeItem('actualPaymentFilters');
    localStorage.removeItem('plannedPaymentFilters');
};

export const clearCookies = () => {
    document.cookie.split(';').forEach(c => {

        const cookieKey = c.trim().split('=')[0];

        if (!(cookieKey === 'Exadel.EIS.Language')) {
            setCookie(cookieKey, '', { expires: new Date(0) });
        }
    });
};

export const logOut = (needClearCookies = true, keycloak) => dispatch => {
    dispatch(finishLogOut());
    clearLocalStorage();

    if (needClearCookies) {
        clearCookies();
    }

    if (keycloak && keycloak.authenticated) history.replace({ pathname: '/' });

    PersistentStorage.setItem('logout', Date.now());

    keycloak.logout();
};
